import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import CollapsableSection from "../../../CustomForms/RenderElements/CollapsableSection";
import { ComponentRef, getComponentRef } from "./MessageTagUtil";
import { getElementToRender } from "../../../CustomForms/RenderElements/ElementDefinitions";

export const MessageLogTagTemplate = {
  component: "MessageLogTag",
};

/**
 * {
 *     "component": "MessageLogTag",
 *     "data": {
 *          formData: [{id: '', value: '', formElement: '', icon: '', label: '', formElementDisplayName: ''}],
 *          logTypeId: '',
 *          logTypeName: ''
 *     }
 * }
 */
const initializeState = (data) => {
  if (data) {
    return data.map((item, index) => {
      return { subIndex: index, isLoaded: false };
    });
  }
  return [];
};

export function MessageLogTag(props) {
  const {
    messageObject,
    objectData,
    handleSubComponentLoaded = (
      subComponent = { ...ComponentRef },
      isLoaded = false
    ) => {},
    messageTime,
    itemIndex,
    level,
  } = props;

  const [subComponents, setSubcomponents] = useState(
    initializeState(objectData.formData)
  );

  useEffect(() => {
    if (objectData.formData) {
      // console.log(`MessageLogTag subcomponents changed`);
      const missingCount = subComponents.filter((c) => !c.isLoaded).length;
      if (
        missingCount === 0 &&
        subComponents.length === objectData.formData.length
      ) {
        handleSubComponentLoaded(
          getComponentRef(
            "MessageLogTag [List]",
            itemIndex,
            level,
            messageTime
          ),
          true
        );
      }
    }
  }, [subComponents]);

  const handleSubComponents = (
    subIndex = 0,
    subComponent = { ...ComponentRef },
    isLoaded = false
  ) => {
    // console.log(`[MessageLogTag] Form Element Loading -> [${subIndex}] ${subComponent.componentName} = ${isLoaded}`);
    const findSubComponent = subComponents.find((c) => c.subIndex === subIndex);
    if (
      isLoaded &&
      findSubComponent &&
      findSubComponent.isLoaded !== isLoaded
    ) {
      setSubcomponents((prevState) => {
        const filteredState = prevState.filter(
          (item) => item.subIndex !== subIndex
        );
        return [...filteredState, { subIndex: subIndex, isLoaded: isLoaded }];
      });
    }
  };

  const renderFormElements = (content) => {
    if (content) {
      return content.map((element, index) => {
        element.messageObject = messageObject;
        element.readOnly = true;
        element.handleSubComponentLoaded = (subComponent, isLoaded) =>
          handleSubComponents(index, subComponent, isLoaded);
        element.itemIndex = itemIndex;
        element.level = level;
        element.messageTime = messageTime;
        element.key = `form-element-${messageTime}-${itemIndex}-${level}-${index}`;

        const filteredDependentElements =
          element?.dependentElements?.filter(
            (u) =>
              u.value !== undefined &&
              u.formElement !== "Paragraph" &&
              u.formElement !== "LineBreak" &&
              u.formElement !== "Header"
          ) ?? [];

        return (
          <Box
            key={`form-element-wrapper-${messageTime}-${itemIndex}-${level}-${index}`}
          >
            {element.formElement !== "Section" && (
              <>
                {getElementToRender(element, "", () => {}, undefined)}
                <Box sx={{ paddingLeft: 2 }}>
                  {element.enableDependentElements &&
                    (element.dependentElements?.length ?? 0) > 0 &&
                    //element.displayDependentElementsWhenValueIs === content.find(u => u.id === element.id)?.value && // Check in here why is using content? Isn't that searching for the element that we already have?
                    element.displayDependentElementsWhenValueIs ===
                      element.value &&
                    renderFormElements(element.dependentElements)}
                </Box>
              </>
            )}

            {element.formElement === "Section" &&
              filteredDependentElements.length > 0 && (
                <CollapsableSection
                  {...element}
                  initialValue={element.value}
                  //initialValue={content.find((u) => u.id === element.id)?.value}
                  onChange={() => {}}
                  readOnly={true}
                >
                  {renderFormElements(filteredDependentElements)}
                </CollapsableSection>
              )}
          </Box>
        );
      });
    }
    return <></>;
  };

  const renderTag = () => {
    const elements = renderFormElements(objectData.formData);
    if (elements) {
      return (
        <Box key={`log-${messageTime}-${itemIndex}-${level}`}>{elements}</Box>
      );
    }
    return false;
  };

  return renderTag();
}
